import { App } from 'vue';
import '@/directives/image-fade-in/image-fade-in.scss';

function onLoad(this: HTMLElement, _event: Event) {
	this.classList.add('image-fade-in--in');
	this.removeEventListener('load', onLoad);
}
// A place to keep global directives.
export const GlobalDirectivesPlugin = {
	install(app: App) {
		app.directive('image-fade-in', {
			beforeMount(el, binding) {
				const image = el as HTMLImageElement;
				if (image.complete !== false) {
					image.classList.remove('image-fade-in--out');
				}
				else if (binding.value !== false) {
					image.classList.add('image-fade-in--out');
				}
			},
			mounted(el, binding) {
				const image = el as HTMLImageElement;
				if (image.complete !== false) {
					image.classList.remove('image-fade-in--out');
				}
				else if (binding.value !== false) {
					image.addEventListener('load', onLoad);
				}
			},
			unmounted(el) {
				el.removeEventListener('load', onLoad);
			},
		});
	},
};
